const link = (param) => {
    return `
    <a href='${param.link}' class='linkTool'>
        ${param.meta.title}
    </a>`
}
module.exports = link
